import React from 'react';

import honestRenovationsImage from '@images_responsive/home/partnerships/honest_renovations.jpg';

import { BaseCard } from './base_card';
import { SizedResponsiveImage } from './sized_responsive_image';

export const HonestRenovationsCard: React.FC = () => (
  <BaseCard
    heading="Honest Renovations"
    subheading="Clutter helps bring Jessica Alba’s The Honest Company to the small screen"
    container="honest_renovations"
    media={
      <SizedResponsiveImage
        image={honestRenovationsImage}
        alt="Clutter helps bring Jessica Alba’s The Honest Company to the small screen"
      />
    }
    body={
      <>
        Clutter is the official partner of the new home renovation show Honest
        Renovations, featuring Jessica Alba and Lizzy Mathis. The show follows
        the hosts as they help families complete home renovations and discuss
        parenting, with eight hour-long episodes set to{' '}
        <a
          href="https://www.tvinsider.com/1041409/honest-renovations-jessica-alba-lizzy-mathis-roku/"
          target="_blank"
        >
          air soon on The Roku Channel
        </a>
        .
      </>
    }
  />
);
